const CSS_CLASSES = {
	ROOT: 'accept_decline',
	OPTION: 'accept_decline__option',
	LABEL_ACCEPT: 'accept_decline__option--accept__label--active',
	LABEL_DECLINE: 'accept_decline__option--decline__label--active',
};

export { CSS_CLASSES };
